import React from 'react';
import get from 'lodash/get';
import { LabeledValue, LabeledValue_Label, LabeledValue_Value } from '../LabeledValue';
import { GridLegacy as Grid } from '@mui/material'; //Grid2 is now recommended and has replaced Grid. GridLegacy is the original component.
import { DataCard_EmptyState } from './DataCard.style';

/**
 * @typedef DataCardBodyProps
 * @property {{[key: string]: string | number}[]} data An array of objects to render as label + value
 * @property {string} labelKey The object property to be rendered as the label
 * @property {string} valueKey The object property to be rendered as the value
 * @property {string} [idKey] The object property to be used as the key in the array.map
 */

/** @type {React.FC<DataCardBodyProps>} */
export var DataCardBody = function DataCardBody(_ref)




{var _ref$data = _ref.data,data = _ref$data === void 0 ? [] : _ref$data,labelKey = _ref.labelKey,valueKey = _ref.valueKey,idKey = _ref.idKey;
  /** @type {React.ReactNode} */
  var children;

  if (data.length) {
    children = data.map(function (item) {return /*#__PURE__*/(
        React.createElement(Grid, {
          item: true,
          key: idKey ? get(item, idKey) : JSON.stringify(item),
          xs: 6 }, /*#__PURE__*/

        React.createElement(LabeledValue, null, /*#__PURE__*/
        React.createElement(LabeledValue_Label, null,
        get(item, labelKey)
        ), /*#__PURE__*/
        React.createElement(LabeledValue_Value, null,
        get(item, valueKey)
        )
        )
        ));}
    );
  } else {
    children = /*#__PURE__*/React.createElement(DataCard_EmptyState, null);
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=DataCardBody.js.map